import { ComVeureEscoltarProps } from './ComVeureEscoltar.types';
// @ts-ignore
import Text from 'components/corporatiu/Text';
// @ts-ignore
import Titol from 'components/corporatiu/Titol/Titol';

const ComVeureEscoltar = (props: Readonly<ComVeureEscoltarProps>) => {
    const { items } = props;

    return (
        <>
            <Titol titol={items?.titol} tipus='menu' tag='h1' estil='titolPagina' />
            <Text text={items?.descripcio} className='gapAfterRow' />
        </>
    );
};

export default ComVeureEscoltar;
